import { render, staticRenderFns } from "./order-receipt-list.vue?vue&type=template&id=01b29285"
import script from "./order-receipt-list.vue?vue&type=script&lang=js"
export * from "./order-receipt-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports